import Button from '@dr-pam/common-components/Components/Form/Button';
import { IconChevronRight } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import React from 'react';

export type FilterSelectorProps<T> = {
	className?: string;
	title?: ReactNode;
	items: T[];
	keyProp: keyof T;
	nameProp: keyof T;
	value?: T;
	onChange?: (value: T | undefined) => void;
};

export default function FilterSelector<T>(props: FilterSelectorProps<T>) {
	const { className, title, keyProp, nameProp, items, value, onChange } = props;

	const [selectedItem, setSelectedItem] = React.useState<T | undefined>(value);

	const handleItemClicked = (item: T) => {
		if (selectedItem === item) {
			setSelectedItem(undefined);
			onChange?.(undefined);
		} else {
			setSelectedItem(item);
			onChange?.(item);
		}
	};

	const sortedItems = items.sort((a, b) => (a[nameProp] as string).localeCompare(b[nameProp] as string));

	return (
		<div className={`FilterSelector ${className ?? ''}`}>
			<div className="header-container">
				{title && <h2>{title}</h2>}
				<div className="prompt-container">
					<span className="scroll-prompt">Scroll to see more</span>
					<IconChevronRight />
				</div>
			</div>
			<div className="items">
				{sortedItems.map((item) => (
					<Button
						key={item[keyProp] as string}
						onClick={() => handleItemClicked(item)}
						className={selectedItem == item ? 'selected' : ''}
					>
						{item[nameProp] as string}
					</Button>
				))}
			</div>
		</div>
	);
}
